<template>
  <div class="card-rule">
    <div class="rule-item" v-for="(rule, index) in ruleList" :key="index">
      <div class="no-wrap">{{ rule.remark }}</div>
      <div class="rule-content">
        <template v-if="rule.ruleContent">
          <div class="flex-item" v-if="['PAYMENT_LIMIT'].includes(rule.ruleType)">
            <el-input-number :controls="false" v-model="rule.ruleContent.perTransaction" :precision="2"></el-input-number>
            <div class="no-wrap">元/笔</div>
          </div>
          <div class="flex-item">
            <el-input-number :controls="false" v-model="rule.ruleContent.perDay" :precision="['GIFT_COUNT', 'RECEIVE_COUNT'].includes(rule.ruleType) ? 0 :2"></el-input-number>
            <div class="no-wrap" >{{['GIFT_COUNT', 'RECEIVE_COUNT'].includes(rule.ruleType) ? '张' : '元'}}/日</div>
          </div>
          <div class="flex-item">
            <el-input-number :controls="false" v-model="rule.ruleContent.perMonth" :precision="['GIFT_COUNT', 'RECEIVE_COUNT'].includes(rule.ruleType) ? 0 :2"></el-input-number>
            <div class="no-wrap" >{{['GIFT_COUNT', 'RECEIVE_COUNT'].includes(rule.ruleType) ? '张' : '元'}}/月</div>
          </div>
          <div class="flex-item" v-if="['PAYMENT_LIMIT'].includes(rule.ruleType)">
            <el-input-number :controls="false" v-model="rule.ruleContent.perYear" :precision="2"></el-input-number>
            <div class="no-wrap">元/年</div>
          </div>
        </template>
      </div>
      <div class="flex-item">
        <el-switch v-model="rule.isEnabled" :width="60" style="margin: 0 40px;"></el-switch>
        <el-button type="primary" size="mini" @click="updateRule(rule)">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      ruleList: []
    }
  },
  mounted () {
    this.getCardRuleList()
  },
  methods: {
    updateRule (rule) {
      this.$http.cardRuleUpdateApi({...rule}).then((res) => {
        if (res.status === 200) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
        this.getCardRuleList()
      }).catch(() => {
        this.getCardRuleList()
      })
    },
    getCardRuleList () {
      this.$http.cardRuleListApi().then((res) => {
        if (res.status === 200) {
          this.ruleList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })

    }
  }
}
</script>
<style lang='scss' scoped>
.card-rule {
  background-color: #fff;
  margin: 20px;
  border-radius: 10px;
  padding: 20px;
}

.rule-item {
  display: flex;
  margin: 20px 0;
  align-items: center;
}

.flex-item {
  display: flex;
  align-items: center;
}

.no-wrap {
  white-space: nowrap;
  margin-left: 10px;
  margin-right: 20px;
}

.rule-content {
  flex: 1;
  display: flex;
  align-items: center;
}
</style>
